<template>
  <div>
    <page-header
      class="mt-4 mt-md-0 mt-sm-4 billing-management__page-header"
      :page="pageHeaderConfig"
    />
    <filter-manager
      ref="filter"
      v-model="filter"
      class="billing-management__filter-manager"
      :display-advanced="false"
      :filters="filterManagerConfig.basic"
      @academicYear="onChangeAcademicYear"
      @active="onChangeActive"
      @adjustment="onChangeAdjustment"
      @search="onSearchHandler"
    />

    <custom-separator class="pt-3 my-4" text="Resultado de Ajustes" />

    <callout-list :data="results" @on-proposal-status-change="search" />

    <custom-result-not-found
      v-if="results.length === 0"
      text="No hay información disponible"
    />

    <pagination
      v-if="results.length > 0 && pagination.totalItemCount > pageSize"
      :data="pagination"
      :page-size="pageSize"
      :show-text="true"
      @pagination-go-page="goToPageHandler"
    />
  </div>
</template>

<script>
import FilterManager from 'FilterManager';
import PageHeader from 'PageHeader';
import {
  getAdjustmentsReasons as _getAdjustmentsReasons,
  getAdjustments,
} from '@/modules/billingAdjustmentManagement/api';
import { getAcademicYearsToCurrentYear as _getAcademicYearsToCurrentYear } from '@/modules/shared/academicyear.api';
import CalloutList from '@/views/provider/billingAdjustmentManagement/components/CalloutList.vue';
import alert from '@/mixins/alert.mixin';
import CustomSeparator from 'custom-separator';
import Pagination from 'pagination';
import CustomResultNotFound from 'custom-result-not-found';

const STORE_MODULE_NAME = 'BillingManagementModule';

export default {
  name: 'ProviderBillingManagement',
  components: {
    PageHeader,
    FilterManager,
    CalloutList,
    CustomSeparator,
    Pagination,
    CustomResultNotFound,
  },
  mixins: [alert],
  data: () => ({
    moduleName: STORE_MODULE_NAME,
    catalog: {
      academicYears: [],
      adjustments: [],
      active: true,
    },
    filter: {
      academicYear: null,
      adjustment: null,
      active: true,
    },
    results: [],
    pagination: {
      totalItemCount: 0,
      count: 0,
      pageCount: 0,
      currentPage: 1,
    },
    pageSize: 15,
  }),
  computed: {
    pageHeaderConfig() {
      return {
        title: 'Manejo de Ajuste de Facturación',
        icon: 'fas fa-user-tie',
        routes: ['Proveedor', 'Manejo de Ajuste de Facturación'],
      };
    },
    filterManagerConfig() {
      return {
        basic: [
          {
            name: 'academicYear',
            component: 'CustomDropDown',
            options: this.catalog.academicYears,
            initialValue:
              this.filter.academicYear || this.currentAcademicYear(),
            placeholder: 'Seleccione el año',
            fieldName: 'description',
            fieldKey: 'id',
            class: 'col-md-4',
            clearable: false,
            clearModelsOnUpdate: ['adjustment'],
          },
          {
            name: 'adjustment',
            component: 'CustomDropDown',
            options: this.catalog.adjustments,
            initialValue: this.filter.adjustment,
            placeholder: 'Seleccione ajuste',
            fieldName: 'name',
            fieldKey: 'id',
            clearable: true,
            class: 'col-md-6',
          },
          {
            name: 'active',
            component: 'CheckBox',
            initialValue: this.filter.active,
            props: { text: 'Activas' },
          },
        ],
      };
    },
  },
  async mounted() {
    await this.getAcademicYears();
    await this.getAdjustmentsReasons();
  },
  methods: {
    onChangeAcademicYear(value) {
      this.filter.academicYear = value;
    },
    onChangeAdjustment(value) {
      this.filter.adjustment = value;
    },
    onChangeActive(value) {
      this.filter.active = value;
    },
    async getAcademicYears() {
      const self = this;
      await _getAcademicYearsToCurrentYear()
        .then((res) => (self.catalog.academicYears = res.data))
        .catch(() => (self.catalog.academicYears = []));
    },
    async getAdjustmentsReasons() {
      const self = this;
      await _getAdjustmentsReasons()
        .then((res) => (self.catalog.adjustments = res))
        .catch(() => (self.catalog.adjustments = []));
    },
    goToPageHandler(page) {
      this.pagination.currentPage = page;
      this.search();
    },
    async onSearchHandler() {
      this.pagination.currentPage = 1;
      this.search();
    },
    async search() {
      const filters = { ...this.filter };

      let params = {
        academicYearId: filters.academicYear ? filters.academicYear.id : null,
        adjustmentTypeId: filters.adjustment ? filters.adjustment.id : null,
        onlyActive: filters.active,
        pageIndex: this.pagination.currentPage,
        pageSize: this.pageSize,
      };

      await getAdjustments(params).then(({ data }) => {
        this.results = [...data.data];
        this.pagination = {
          ...this.pagination,
          count: data.count,
          currentPage: data.currentPage,
          pageCount: data.pageCount,
          totalItemCount: data.totalItemCount,
        };
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';

::v-deep .input-label {
  color: map-get($colors, 'gray-6');
  font-size: 14px !important;
  font-weight: normal !important;
}

.billing-management {
  &__page-header ::v-deep {
    @media only screen and (max-width: 768px) {
      .actions {
        display: flex !important;
      }
      .ab-btn.success {
        width: auto;
      }
    }
  }
  &__filter-manager ::v-deep {
    .ab-btn.success {
      margin-right: 20px;
      width: 86%;
    }
  }
}

@media only screen and (max-width: 768px) {
}
</style>
